import styled from 'styled-components';


export const SocialMediaSection = styled.div `
    height: auto;
    overflow: hidden;
    width: 100%;
`
export const Socail = styled.div `
    width: 33.33%;
    float: left;
    box-sizing: border-box;
    padding: 100px 0 100px 60px;
    font-family: sans-serif;
    background: #3b5998;

`


export const SocialMediaTwitter = styled.div `
    width: 33.33%;
    float: left;
    box-sizing: border-box;
    padding: 100px 0 100px 60px;
    font-family: sans-serif;
    background: #498cbf;

`

export const SocialMediaPin = styled.div `
    width: 33.33%;
    float: left;
    box-sizing: border-box;
    padding: 100px 0 100px 60px;
    font-family: sans-serif;
    background: #cc2127;

`
export const Icon = styled.i `
    width: 50px;
    height: 50px;
    background: #fff;
    text-align: center;
    line-height: 50px;
    color: #888;
    float: left;
    margin-right: 10px;

    &:hover {
        background: #252525;
    }
    
`
export const SocailP = styled.div `
    font-weight: bold;
    text-transform: uppercase;
    font-size: 20px;
    color: #fff;
    font-family: sans-serif;
`

export const SocailPSpan = styled.span `
    display: block;
    margin-bottom: 8px;
    font-family: sans-serif;
`

export const Info2 = styled.span `
    font-weight: normal;
    font-family: sans-serif;
` 

